import React,{useState} from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Box,
  Paper,
  Avatar,Snackbar, Alert
} from "@mui/material";
import { keyframes, styled } from "@mui/system";
import BusinessIcon from "@mui/icons-material/Business";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { MailLock, MailOutline, Person2Rounded } from "@mui/icons-material";
import emailjs from "@emailjs/browser";


const randomFloatAnimation = keyframes`
  0% { transform: translate(0, 0); }
  25% { transform: translate(10px, -15px) rotate(10deg); }
  50% { transform: translate(-10px, 10px) rotate(-10deg); }
  75% { transform: translate(15px, -10px) rotate(5deg); }
  100% { transform: translate(0, 0); }
`;

const GradientBox = styled(Box)({
  position: "relative",
  background: "linear-gradient(135deg, #ff7e5f, #feb47b)",
  padding: "4rem 0",
  textAlign: "center",
  color: "white",
  overflow: "hidden",
});


const FloatingAvatar = styled(Avatar)(({ delay }) => ({
  position: "absolute",
  width: 50,
  height: 50,
  border: "2px solid white",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  animation: `${randomFloatAnimation} ${
    Math.random() * 4 + 3
  }s infinite ease-in-out`,
  animationDelay: delay,
}));

const avatarPositions = [
  { top: "10%", left: "15%" },
  { top: "15%", right: "20%" },
  { top: "30%", left: "50%" },
  { top: "20%", right: "40%" },
  { top: "35%", left: "10%" },
  { top: "40%", right: "5%" },
];



const Background = styled(Box)({
  backgroundImage: `url('https://cdni.iconscout.com/illustration/premium/thumb/contact-us-illustration-download-in-svg-png-gif-file-formats--call-logo-laptop-helping-customer-service-pack-network-communication-illustrations-2912020.png?f=webp')`,
  backgroundRepeat:'no-repeat',
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  padding: "60px 0",
});

const GlassCard = styled(Paper)({
  background: "rgba(30, 30, 30, 0.9)",
  backdropFilter: "blur(8px)",
  borderRadius: "20px",
  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.5)",
  padding: "40px",
  textAlign: "center",
  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: "0px 12px 30px rgba(0, 0, 0, 0.7)",
  },
});

const StyledButton = styled(Button)({
  background: "linear-gradient(135deg, #333333, #444444)",
  color: "#f5f5f5",
  padding: "12px 36px",
  fontSize: "16px",
  fontWeight: "bold",
  borderRadius: "30px",
  textTransform: "none",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    background: "linear-gradient(135deg, #444444, #555555)",
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.5)",
  },
});

const InfoRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginBottom: "20px",
  "& svg": {
    color: "#fff", // Gold accent for icons
    marginRight: "16px",
    fontSize: "28px",
  },
});



const Contact = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // or 'error'


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const sendEmail = (e) => {
  e.preventDefault();
  emailjs
    .send(
      "service_uma7kd5",
      "template_p214fdk",
      {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        subject: formData.subject,
        message: `NAME: ${formData.firstName} ${formData.lastName} | EMAIL : ${formData.email} | MESSAGE :  ${formData.message}`,
      },
      "8qyP821NcV0Nv5_kE"
    )
    .then(
      (response) => {
        setSnackbarMessage('Message sent successfully!');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          subject: "",
          message: "",
        });
      },
      (error) => {
        console.error("Failed to send message:", error);
        setSnackbarMessage('Failed to send message. Please try again.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    );
};

  const sendToWhatsApp = (e) => {
  e.preventDefault();

  const phoneNumber = "917021969470"; // Replace with your number, e.g., '918888888888'
  const message = `Name: ${formData.firstName} ${formData.lastName}%0AEmail: ${formData.email}%0ASubject: ${formData.subject}%0AMessage: ${formData.message}`;

  const url = `https://wa.me/${phoneNumber}?text=${message}`;
  window.open(url, "_blank"); // Opens WhatsApp chat in a new tab
};
  return (
    <Background>
      <Container maxWidth="lg">
    
        
        <Snackbar
  open={snackbarOpen}
  autoHideDuration={4000}
  onClose={() => setSnackbarOpen(false)}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
>
  <Alert
    onClose={() => setSnackbarOpen(false)}
    severity={snackbarSeverity}
    sx={{ width: '100%' }}
  >
    {snackbarMessage}
  </Alert>
</Snackbar>
       
   
        <Grid container spacing={5} alignItems="center">
          {/* Contact Information Section */}
          <Grid item xs={12} md={4}>
            <GlassCard>
              <Typography
                variant="h3"
                component="h2"
                sx={{
                  fontWeight: "bold",
                  color: "#1F473E",
                  marginBottom: "20px",
                 // textTransform: "uppercase",
                }}
              >
                Get in Touch with us
              </Typography>
              <Typography
                variant="p"
                component="h2"
                sx={{
                  fontWeight: "bold",
                  color: "#D4C9B6",
                  marginBottom: "20px",
                 // textTransform: "uppercase",
                }}
              >
                Contact us here
              </Typography>
              <InfoRow>
                <BusinessIcon />
                <Typography variant="body1" color="text.secondary" sx={{ color: "#e0e0e0" }}>
                  Unispherexim
                </Typography>
              </InfoRow>
              <InfoRow>
                <MailOutlineIcon />
                <Typography variant="body1" color="text.secondary" sx={{ color: "#e0e0e0" }}>
                info@unisphereexim.com
                </Typography>
              </InfoRow>
              <InfoRow>
                <Person2Rounded />
                <Typography variant="body1" color="text.secondary" sx={{ color: "#e0e0e0" }}>
                info@unispherexim.com
                </Typography>
              </InfoRow>
              <InfoRow>
                <PhoneInTalkIcon />
                <Typography variant="body1" color="text.secondary" sx={{ color: "#e0e0e0" }}>
                  +91 7021969470
                </Typography>
              </InfoRow>
              <InfoRow>
                <LocationOnIcon />
                <Typography variant="body1" color="text.secondary" sx={{ color: "#e0e0e0" }}>
Shop no 02, Moreshwar CHS, Vichumbe, Panvel, Navi Mumbai, Maharashtra, India - 410206                    </Typography>
              </InfoRow>
            </GlassCard>
          </Grid>

          {/* Contact Form Section */}
          <Grid item xs={12} md={8}>
            <GlassCard>
              <Typography
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: "bold",
                  color: "#ffffff",
                  marginBottom: "20px",
                  textTransform: "uppercase",
                }}
              >
                Send Us a Message
              </Typography>
              <form>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="First Name"
                      variant="outlined"
                      name="firstName"
                      onChange={handleChange}
                      value={formData.firstName}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#757575",
                          },
                          "&:hover fieldset": {
                            borderColor: "#999999",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff",
                          },
                        },
                        "& .MuiInputBase-input": { color: "#ffffff" },
                        "& .MuiInputLabel-root": { color: "#bdbdbd" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      variant="outlined"
                      name="lastName"
                      value={formData.lastName}

                      onChange={handleChange}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#757575",
                          },
                          "&:hover fieldset": {
                            borderColor: "#999999",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff",
                          },
                        },
                        "& .MuiInputBase-input": { color: "#ffffff" },
                        "& .MuiInputLabel-root": { color: "#bdbdbd" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email Address"
                      type="email"
                      variant="outlined"
                      name="email"
                      value={formData.email}

                      onChange={handleChange}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#757575",
                          },
                          "&:hover fieldset": {
                            borderColor: "#999999",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff",
                          },
                        },
                        "& .MuiInputBase-input": { color: "#ffffff" },
                        "& .MuiInputLabel-root": { color: "#bdbdbd" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#757575",
                          },
                          "&:hover fieldset": {
                            borderColor: "#999999",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff",
                          },
                        },
                        "& .MuiInputBase-input": { color: "#ffffff" },
                        "& .MuiInputLabel-root": { color: "#bdbdbd" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Message"
                      multiline
                      rows={4}
                      name="message"
                      onChange={handleChange}
                      value={formData.message}
                      variant="outlined"
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#757575",
                          },
                          "&:hover fieldset": {
                            borderColor: "#999999",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff",
                          },
                        },
                        "& .MuiInputBase-input": { color: "#ffffff" },
                        "& .MuiInputLabel-root": { color: "#bdbdbd" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <StyledButton variant="contained" type="submit" onClick={sendEmail}>
                      Submit
                    </StyledButton>
                  </Grid>
                </Grid>
              </form>
            </GlassCard>
          </Grid>
        </Grid>
      </Container>
    </Background>
  );
};

export default Contact;
